export const SHARE_SHOW = 'SHARE_SHOW';
export const SHARE_HIDE = 'SHARE_HIDE';
